import { LEFT_MENU_HIDE, LEFT_MENU_SHOW } from "../actions/LeftMenuActions";

const initialState = { displayMenu: true };

export default function leftMenuReducer(state = initialState, action) {
  switch (action.type) {
    case LEFT_MENU_SHOW:
      return {...state, displayMenu: true};
    case LEFT_MENU_HIDE:
      return {...state, displayMenu: false};
  }
  return state;
}
